import { IEnvironment } from '../app/core/interfaces/IEnvironment';

export const environment: IEnvironment = {
  production: false,
  config_path: '/data/config/pwa.config.json',
  new_config_path: '/data/config/lp-config.json',
  app_config: null,
  new_config: null,
};
